import {
  CompanyLocalizationDataOutSchema,
  GlnCodeDistanceSchema,
} from './types';
import { client } from 'src/utils/api-client';
import { useMutation } from 'react-query';

// eslint-disable-next-line import/prefer-default-export
export const useGlnCodes = () => {
  const fetchGlnCode = useMutation((code: string) =>
    client.get<CompanyLocalizationDataOutSchema[]>(`/web/gln-codes`, {
      params: {
        gln_code: code,
      },
    })
  );

  const fetchDistances = useMutation((glnCodes: string[]) =>
    client.post<GlnCodeDistanceSchema[]>('/web/gln-codes/distances', {
      gln_codes: glnCodes,
    })
  );

  return {
    fetchGlnCode,
    fetchDistances,
  };
};
